module.exports = __webpack_public_path__ + "img/ru_img3.efdedbe3.png";